import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import {
	DatePicker,
	Row,
	Col,
	Button,
	Select,
	notification,
	Typography,
	Flex,
} from "antd";
import dayjs from "dayjs";
import axios from "axios";
import { api } from "../utils/Api";
import { CustomTable } from "../utils/CustomComponents";
import QAQCAddComATicketModal from "../pouring/QAQCAddComATicketModal";
import {
	CheckCircleOutlined,
	EditOutlined,
	EyeOutlined,
	PlusCircleOutlined,
	RetweetOutlined,
	UploadOutlined,
} from "@ant-design/icons";
const { RangePicker } = DatePicker;
const { Text } = Typography;

const ALLOWED_EMAILS = [
	"aca@57concrete.com",
	"jm@57concrete.com",
	"js@57concrete.com",
	"js1@57concrete.com",
];

const EticketJobDownload = ({ history }) => {
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [plants, setPlants] = useState([]);
	const [plant, setPlant] = useState("All");
	const [loading, setLoading] = useState(true);
	const [loadingTable, setLoadingTable] = useState(true);
	const [jobList, setJobList] = useState([]);
	const [customerList, setCustomerList] = useState(true);
	const [customer, setCustomer] = useState(undefined);
	const [customerLoading, setCustomerLoading] = useState(true);
	const [apiNotification, contextHolder] = notification.useNotification();

	const [openComATicketModal, setOpenComATicketModal] = useState(false);
	const [selectedJob, setSelectedJob] = useState(null);
	const [refresh, setRefresh] = useState(false);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Date",
			dataIndex: "scheduledDate",
			key: "scheduledDate",
			sorter: (a, b) =>
				dayjs(a.scheduledDate).valueOf() - dayjs(b.scheduledDate).valueOf(),
			render: (value) => {
				if (!value || !dayjs(value).isValid()) return "-";
				return <Text>{dayjs(value).format("MM/DD/YYYY hh:mm A")}</Text>;
			},
		},
		{
			title: "Job ID",
			dataIndex: "jobId",
			key: "jobId",
			sorter: (a, b) => Number(a.jobId) - Number(b.jobId),
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Customer",
			dataIndex: "customer",
			key: "customer",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Address",
			dataIndex: "address",
			key: "address",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Loaded YD3",
			dataIndex: "loadYD3",
			key: "loadYD3",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Target YD3",
			dataIndex: "targetYD3",
			key: "targetYD3",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "",
			dataIndex: "actions",
			key: "actions",
			render: (_, record) => {
				return (
					<Flex gap={10}>
						<Button
							type="primary"
							onClick={() => {
								const url = "/eticketsjob/" + record.id;
								history.push(url);
							}}
						>
							Etickets
						</Button>
						<Button
							type="primary"
							onClick={() => {
								setOpenComATicketModal(true);
								setSelectedJob(record);
							}}
							disabled={record.comATicketUrl}
							icon={
								record.comATicketUrl ? (
									<CheckCircleOutlined />
								) : (
									<PlusCircleOutlined />
								)
							}
						>
							ComA-Ticket
						</Button>
						{record.comATicketUrl && (
							<Button
								type="default"
								size="small"
								icon={<EyeOutlined />}
								onClick={() => {
									const url = record.comATicketUrl;
									if (url) {
										window.open(url, "_blank", "noopener,noreferrer");
									}
								}}
							/>
						)}
					</Flex>
				);
			},
		},
	];

	useEffect(() => {
		// if (!ALLOWED_EMAILS.includes(localStorage.getItem("email"))) {
		// 	history.push("/");
		// 	return;
		// }
		getPlants();
		getCustomers();
	}, []);

	useEffect(() => {
		getJobs();
	}, [startDate, endDate, plant, customer, refresh]);

	const getCustomers = async () => {
		try {
			const url = api + "/customer/list/options/57Concrete";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						label: `${item.customerNumber} ${item.name}`,
						value: item._id,
					});
				});
				setCustomerList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setCustomerLoading(false);
		} catch (err) {
			setCustomerLoading(false);
			openNotification("error", "Error", "Error while trying to get customers");
			console.error(err.message);
			return null;
		}
	};

	const getPlants = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [
				{
					label: "All",
					value: "All",
				},
			];
			data.payload.map((item) => {
				list.push({
					value: item._id,
					label: item.name,
				});
			});
			setPlants(list);
			setPlant(list[0].value);
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getJobs = async () => {
		setLoadingTable(true);
		const start = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const url =
			api +
			`/job/get/etickets/dates/57Concrete?startDate=${start}&endDate=${end}&plant=${plant}&customer=${customer}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						key: item._id,
						index: item._id,
						id: item._id,
						scheduledDate: item.scheduledDate,
						jobId: item.number,
						customer: item.customer.name,
						plant: item.plant.name,
						franchise: item.franchise,
						address: `${item.shipAddress} - ${item.customerShipAddress}`,
						targetYD3: item.targetYD3,
						loadYD3: item.loadYD3,
						comATicketUrl: item.comATicketUrl,
					});
				});
				setJobList(list);
			} else {
				openNotification(
					"warning",
					"Warning",
					"This plant/customer do not have jobs assigned",
				);
			}
			setLoadingTable(false);
		} catch (err) {
			openNotification("error", "Error", "Cannot get jobs");
			setLoading(false);
			console.error(err.message);
			return null;
		}
	};
	const getLoads = async () => {
		if (!plant) {
			openNotification("warning", "Warning", "Plant must be selected");
			return null;
		}

		setLoading(true);
		const start = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const url =
			api +
			`/etickets/job/dates/57Concrete?startDate=${start}&endDate=${end}&plant=${plant}&customer=${customer}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.post(url);
			setLoading(false);

			if (data === "") {
				openNotification(
					"warning",
					"Warning",
					"This plant/customer do not have jobs assigned",
				);
			} else {
				const link = document.createElement("a");
				link.href = data;
				link.download = "";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				openNotification("success", "Success", "Zip generated");
			}
		} catch (err) {
			openNotification("error", "Error", "Cannot generate zip");
			setLoading(false);
			console.error(err.message);
			return null;
		}
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const RenderDates = () => (
		<RangePicker
			defaultValue={[
				dayjs(startDate, "MM/DD/YYYY"),
				dayjs(endDate, "MM/DD/YYYY"),
			]}
			onChange={onRangeChange}
			format={"MM/DD/YYYY"}
			size="large"
			disabled={loading || loadingTable}
			allowClear={false}
			style={{
				width: "100%",
			}}
		/>
	);

	const onChangePlant = (value) => {
		if (value) {
			setPlant(value);
		}
	};
	const onChangeCustomer = (value) => {
		setCustomer(value);
	};

	const RenderSelectPlant = () => (
		<Select
			style={{
				width: "100%",
			}}
			size="large"
			placeholder="Please select a plant"
			value={plant}
			options={plants}
			disabled={loading || loadingTable}
			loading={loading || loadingTable}
			optionFilterProp="children"
			onChange={onChangePlant}
		/>
	);

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const RenderSelectCustomer = () => (
		<Select
			style={{
				width: "100%",
			}}
			size="large"
			placeholder="Please select a customer"
			value={customer}
			options={customerList}
			disabled={customerLoading || loading || loadingTable}
			loading={customerLoading || loading || loadingTable}
			optionFilterProp="children"
			onChange={onChangeCustomer}
			allowClear={true}
			filterOption={filterOption}
			showSearch
		/>
	);

	const RenderTable = () => {
		return (
			<CustomTable
				columns={columns}
				data={jobList}
				loading={loading || loadingTable}
				isScroll={true}
			/>
		);
	};

	return (
		<Layout title="Eticket Consolidated Report" description="Report/Download">
			<Flex vertical gap={16}>
				<Flex gap={16} align="end" justify="space-between">
					<Row gutter={[16, 16]} style={{ width: "100%" }}>
						<Col span={4}>
							<RenderDates />
						</Col>
						<Col span={4}>
							<RenderSelectPlant />
						</Col>
						<Col span={6}>
							<RenderSelectCustomer />
						</Col>
					</Row>
					<Button
						type="primary"
						onClick={() => setRefresh((prev) => !prev)}
						icon={<RetweetOutlined />}
						size="large"
						loading={loading}
					/>
				</Flex>
				<RenderTable />
				<Button
					type="primary"
					size="large"
					onClick={() => getLoads()}
					loading={loading}
					disabled={loading}
				>
					Download Zip
				</Button>
			</Flex>
			<QAQCAddComATicketModal
				setOpenComATicketModal={setOpenComATicketModal}
				openComATicketModal={openComATicketModal}
				setRefresh={setRefresh}
				setSelectedJob={setSelectedJob}
				selectedJob={selectedJob}
			/>
			{contextHolder}
		</Layout>
	);
};

export default EticketJobDownload;
